module.exports = __webpack_public_path__ + "img/card_220260566.d645d9d0.png";